const defaultLocale = 'en';

export const getUrlLocale = () => {
  try {
    // en, jp, zh-TW, zh-CN
    const locale = window.location.pathname.match(/((en|jp|zh-TW|zh-CN)+)\//)[1]
    return locale;
  } catch (e) {
    return defaultLocale;
  }
}